/**
 * KUMAMOTO HORSE — site.js
 *
 * 静的デモ用の共通 JS。Shopify 移行時は個別機能に置換される想定で、
 * 各機能は独立関数として export-like に分離してある。
 */
(function () {
  'use strict';

  // ------------------------------------------------------------------
  // Toast (ephemeral message shown at bottom-center)
  // ------------------------------------------------------------------
  function showToast(message, opts) {
    opts = opts || {};
    var host = document.querySelector('.toast-host');
    if (!host) {
      host = document.createElement('div');
      host.className = 'toast-host';
      host.setAttribute('role', 'status');
      host.setAttribute('aria-live', 'polite');
      document.body.appendChild(host);
    }
    var el = document.createElement('div');
    el.className = 'toast' + (opts.tone === 'success' ? ' is-success' : '');
    el.textContent = message;
    host.appendChild(el);
    // Trigger transition
    requestAnimationFrame(function () { el.classList.add('is-shown'); });
    var ms = opts.duration || 2600;
    setTimeout(function () {
      el.classList.remove('is-shown');
      setTimeout(function () { el.remove(); }, 300);
    }, ms);
  }
  window.KH = window.KH || {};
  window.KH.toast = showToast;

  // ------------------------------------------------------------------
  // Mobile menu
  //   開閉・トランジション・フォーカス管理をここに一本化する。
  //   display の切替ではアニメーションできないため、is-open クラスと
  //   visibility で制御する（CSS 側とセット）。
  // ------------------------------------------------------------------
  function initMobileMenu() {
    var panel    = document.querySelector('[data-nav-panel]');
    var toggle   = document.querySelector('[data-nav-toggle]');
    var backdrop = document.querySelector('[data-nav-backdrop]');
    var closeBtn = panel && panel.querySelector('[data-nav-close]');
    if (!panel || !toggle) return;

    var open = false;

    function setOpen(next, opts) {
      opts = opts || {};
      open = next;
      panel.classList.toggle('is-open', open);
      if (backdrop) backdrop.classList.toggle('is-open', open);
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';

      if (open) {
        // トランジション開始後にフォーカスを移す（visibility 切替直後は移せない）
        setTimeout(function () {
          var first = panel.querySelector('a, button');
          if (first) first.focus({ preventScroll: true });
        }, 60);
      } else if (!opts.keepFocus) {
        toggle.focus({ preventScroll: true });
      }
    }

    toggle.addEventListener('click', function () { setOpen(!open); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
    if (backdrop) backdrop.addEventListener('click', function () { setOpen(false); });

    // メニュー内のリンクを踏んだら閉じる（同一ページ内アンカー対策）
    panel.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a')) setOpen(false, { keepFocus: true });
    });

    // Escape で閉じる
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) setOpen(false);
    });

    // 開いている間はフォーカスをパネル内に閉じ込める
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !open) return;
      var focusables = panel.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last  = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });

    // PC 幅に広がったら状態をリセットする（開きっぱなし防止）
    var mq = window.matchMedia('(min-width: 901px)');
    function onBreak() { if (mq.matches && open) setOpen(false, { keepFocus: true }); }
    if (mq.addEventListener) mq.addEventListener('change', onBreak);
    else if (mq.addListener) mq.addListener(onBreak);
  }

  // ------------------------------------------------------------------
  // Cart click → toast (demo)
  // ------------------------------------------------------------------
  // Shopify 移行後、カート追加は実フォーム送信で処理される。
  // ここでは二重クリック防止のみ担当する（デモ用トーストは廃止）。
  function initCartButtons() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('.kh-quick-add, .kh-product-form')) return;
      var btn = form.querySelector('button[type=submit]');
      if (!btn || btn.disabled) return;
      btn.dataset.khLabel = btn.textContent.trim();
      btn.disabled = true;
      // 送信が中断された場合に備えて復帰させる
      setTimeout(function () {
        btn.disabled = false;
        if (btn.dataset.khLabel) btn.textContent = btn.dataset.khLabel;
      }, 4000);
    });
  }

  // ------------------------------------------------------------------
  // Product Detail tabs
  //   PC: タブ。常にどれか1つが開いている。
  //   スマホ: アコーディオン。初期はすべて閉じていて、
  //           開いているものをもう一度押すと閉じる。
  //           1つ開くと他は閉じる（idx を1つしか持たないため自動的にそうなる）。
  // ------------------------------------------------------------------
  function initProductTabs() {
    var tablist = document.querySelector('.product-tabs .tab-buttons');
    if (!tablist) return;
    var buttons = Array.prototype.slice.call(tablist.querySelectorAll('.tab-btn'));
    var panels  = Array.prototype.slice.call(document.querySelectorAll('.product-tabs .tab-content'));
    if (!buttons.length || !panels.length) return;

    var mq   = window.matchMedia('(max-width: 720px)');
    var open = mq.matches ? -1 : 0;   // -1 = すべて閉じている

    function isAccordion() { return mq.matches; }

    buttons.forEach(function (btn, i) {
      btn.setAttribute('id', 'tab-btn-' + i);
      btn.setAttribute('aria-controls', 'tab-panel-' + i);
      btn.addEventListener('click', function () {
        // アコーディオンのときだけ、開いているものを押すと閉じる
        activate(isAccordion() && open === i ? -1 : i);
      });
      btn.addEventListener('keydown', function (e) {
        var next = i;
        if (e.key === 'ArrowRight') next = (i + 1) % buttons.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + buttons.length) % buttons.length;
        else return;
        e.preventDefault();
        activate(next);
        buttons[next].focus();
      });
    });

    panels.forEach(function (p, i) {
      p.setAttribute('id', 'tab-panel-' + i);
      p.setAttribute('role', 'tabpanel');
      p.setAttribute('aria-labelledby', 'tab-btn-' + i);
    });

    function activate(idx) {
      open = idx;
      var acc = isAccordion();
      buttons.forEach(function (b, i) {
        var on = i === idx;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        // アコーディオンは見出しなので全部たどれるようにする。
        // タブのときは選択中だけを Tab の対象にして矢印キーで移動する。
        b.setAttribute('tabindex', acc ? '0' : (on ? '0' : '-1'));
      });
      panels.forEach(function (p, i) { p.hidden = i !== idx; });
    }

    activate(open);

    // 画面幅が変わったとき、PC 側は必ず1つ開いた状態に戻す
    function onBreakpoint() {
      if (!mq.matches && open === -1) activate(0);
      else activate(open);
    }
    if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
    else if (mq.addListener) mq.addListener(onBreakpoint);
  }

  // ------------------------------------------------------------------
  // Quantity picker
  // ------------------------------------------------------------------
  function initQuantityPickers() {
    document.querySelectorAll('.qty-picker').forEach(function (picker) {
      var minus = picker.querySelector('.qty-btn[aria-label*="減"]');
      var plus  = picker.querySelector('.qty-btn[aria-label*="増"]');
      var val   = picker.querySelector('.qty-value');
      if (!minus || !plus || !val) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      input.value = val.textContent.trim();
      picker.appendChild(input);
      function set(n) {
        n = Math.max(1, Math.min(99, n));
        val.textContent = n;
        input.value = n;
        minus.disabled = n <= 1;
        plus.disabled  = n >= 99;
      }
      minus.addEventListener('click', function () { set(parseInt(val.textContent, 10) - 1); });
      plus .addEventListener('click', function () { set(parseInt(val.textContent, 10) + 1); });
      set(parseInt(val.textContent, 10) || 1);
    });
  }

  // ------------------------------------------------------------------
  // Contact form: dummy submit → toast + reset
  // ------------------------------------------------------------------
  // Shopify の contact form は実際に POST するので preventDefault しない。
  // 二重送信の防止と送信中表示だけを担当する。
  function initContactForm() {
    var form = document.querySelector('.contact-form');
    if (!form) return;
    form.addEventListener('submit', function () {
      if (!form.checkValidity()) return;      // ブラウザ標準の検証に任せる
      var btn = form.querySelector('.btn-submit');
      if (btn) { btn.disabled = true; btn.textContent = '送信中…'; }
    });
  }

  // ------------------------------------------------------------------
  // Instagram slider: measure the natural width of the first half and
  // animate translation by exactly that distance so the loop is seamless.
  // ------------------------------------------------------------------
  function initInstagramSlider() {
    var track = document.querySelector('.instagram-track');
    if (!track) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var cells = track.children;
    if (cells.length < 2) return;
    var half = Math.floor(cells.length / 2);
    var gap  = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;

    function apply() {
      var width = 0;
      for (var i = 0; i < half; i++) {
        width += cells[i].getBoundingClientRect().width + gap;
      }
      track.style.setProperty('--insta-shift', width + 'px');
      // Speed: 1 cell per ~6.6s
      var duration = (half * 6.6);
      track.style.setProperty('--insta-duration', duration + 's');
    }
    apply();
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(apply, 150);
    });
    window.KH = window.KH || {};
    window.KH.remeasureInsta = apply;
  }

  // ------------------------------------------------------------------
  // Products filter (list page): ARIA + empty state
  // ------------------------------------------------------------------
  function initProductsFilter() {
    var buttons = document.querySelectorAll('.product-filter .filter-btn');
    if (!buttons.length) return;
    var cards = document.querySelectorAll('.products-list .product-card[data-group]');
    var grid  = document.querySelector('.products-list .product-grid');
    if (!grid) return;

    // Empty state
    var empty = document.createElement('p');
    empty.className = 'products-empty';
    empty.textContent = '該当する商品が見つかりませんでした。';
    empty.hidden = true;
    grid.parentNode.insertBefore(empty, grid.nextSibling);

    buttons.forEach(function (btn) {
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-pressed', btn.classList.contains('is-active') ? 'true' : 'false');
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        var f = btn.dataset.filter;
        var visible = 0;
        cards.forEach(function (c) {
          var show = (f === 'all' || c.dataset.group === f);
          c.hidden = !show;
          if (show) visible++;
        });
        empty.hidden = visible > 0;
      });
    });
  }

  // ------------------------------------------------------------------
  // Pin scroll — page vertical scroll drives horizontal section slide.
  // For each [data-pin], we translate its [data-pin-track] by the amount
  // of horizontal overflow, proportional to how far the pin-section has
  // scrolled past the viewport top. Disabled on narrow / reduced-motion.
  // ------------------------------------------------------------------
  function initPinScroll() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = function () { return window.innerWidth <= 720; };
    var pins = Array.prototype.slice.call(document.querySelectorAll('[data-pin]'));
    if (!pins.length) return;

    function measure(pin) {
      var track = pin.querySelector('[data-pin-track]');
      if (!track) return 0;
      if (isMobile() || reduce) {
        pin.style.setProperty('--pin-overflow', '0px');
        pin.classList.remove('is-pinning');
        track.style.transform = '';
        return 0;
      }
      // trackWidth = intrinsic scroll width. viewport = section width.
      var vw = pin.clientWidth;
      // Include padding of track (inset gutters) so overflow is real horizontal room
      var contentWidth = 0;
      Array.prototype.forEach.call(track.children, function (child) {
        contentWidth += child.getBoundingClientRect().width;
      });
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      if (track.children.length > 1) contentWidth += gap * (track.children.length - 1);
      var padL = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      var padR = parseFloat(getComputedStyle(track).paddingRight) || 0;
      var totalTrack = contentWidth + padL + padR;
      var overflow = Math.max(0, totalTrack - vw);
      pin.style.setProperty('--pin-overflow', overflow + 'px');
      pin.classList.toggle('is-pinning', overflow > 0);
      return overflow;
    }

    function apply() {
      pins.forEach(function (pin) {
        var track = pin.querySelector('[data-pin-track]');
        if (!track) return;
        if (isMobile() || reduce) { track.style.transform = ''; return; }
        var overflow = parseFloat(pin.style.getPropertyValue('--pin-overflow')) || 0;
        if (overflow <= 0) { track.style.transform = ''; return; }
        var rect = pin.getBoundingClientRect();
        // Progress: 0 when section top hits viewport top, 1 when we have scrolled `overflow` px past.
        var progress = Math.min(1, Math.max(0, -rect.top / overflow));
        track.style.transform = 'translate3d(' + (-progress * overflow) + 'px, 0, 0)';
      });
    }

    function measureAll() { pins.forEach(measure); apply(); }
    measureAll();

    // Re-measure after images/fonts load
    window.addEventListener('load', measureAll);
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measureAll, 120);
    });

    // Scroll handler with rAF throttling
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { apply(); ticking = false; });
    }, { passive: true });
  }

  // ------------------------------------------------------------------
  // SNS tabs (Instagram / TikTok switcher)
  // ------------------------------------------------------------------
  function initSnsTabs() {
    var tabs   = document.querySelectorAll('.sns-tab');
    var panels = document.querySelectorAll('.sns-panel');
    if (!tabs.length || !panels.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.snsTab;
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.dataset.snsPanel !== target;
        });
        // Re-measure instagram slider if it just became visible
        if (target === 'instagram' && window.KH && window.KH.remeasureInsta) {
          window.KH.remeasureInsta();
        }
      });
    });
  }

  // ------------------------------------------------------------------
  // Footer accordion: <details> is open by default (so links render on
  // desktop even where UA styles resist override). On mobile, collapse
  // them so the footer stays compact.
  // ------------------------------------------------------------------
  function initFooterAccordion() {
    var mq = window.matchMedia('(max-width: 720px)');
    var details = document.querySelectorAll('.footer .footer-col');
    if (!details.length) return;
    function sync() {
      details.forEach(function (d) {
        if (mq.matches) d.removeAttribute('open');
        else            d.setAttribute('open', '');
      });
    }
    sync();
    mq.addEventListener('change', sync);
  }


  // ------------------------------------------------------------------
  // オプションの選択（解体方法など）
  //   商品名の下のボタンで選ぶと、以下がすべて連動して切り替わる。
  //     ・上部の価格と「選択中」ラベル
  //     ・価格の下に出る、そのオプションの内容
  //     ・フォームに入るバリエーション id
  //     ・カートボタンの状態（売り切れなら押せない）
  //   売り切れのオプションもボタン自体は押せる（内容は見られる）。
  // ------------------------------------------------------------------
  function initVariantSelect() {
    var box = document.querySelector('[data-kh-variant-select]');
    if (!box) return;

    var btns    = Array.prototype.slice.call(box.querySelectorAll('.variant-btn'));
    var panels  = Array.prototype.slice.call(document.querySelectorAll('[data-kh-variant-panel]'));
    var buys    = Array.prototype.slice.call(document.querySelectorAll('[data-kh-variant-purchase]'));
    var idInput = document.querySelector('[data-kh-variant-id]');
    var planInp = document.querySelector('[data-selling-plan]');
    var priceEl = document.querySelector('.price-large');
    var labelEl = document.querySelector('[data-kh-selected-label]');
    var cartBtn = document.querySelector('[data-kh-cart-btn]');
    var cartTxt = cartBtn ? cartBtn.querySelector('span') : null;
    if (!btns.length) return;

    // 選択は必須。選ぶまではどの内容も出さず、カートにも入れられない。
    function unselect() {
      btns.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-checked', 'false');
        b.setAttribute('tabindex', '0');
      });
      panels.forEach(function (p) { p.hidden = true; });
      buys.forEach(function (f) { f.hidden = true; });
      if (planInp) planInp.value = '';
      if (labelEl) labelEl.textContent = '';
      if (cartBtn) {
        cartBtn.disabled = true;
        if (cartTxt) cartTxt.textContent = 'オプションをお選びください';
      }
    }

    function select(i) {
      btns.forEach(function (b, n) {
        var on = n === i;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (p, n) { p.hidden = n !== i; });

      // お届け方法は選んだバリエーションのものだけを出し、
      // 切り替えたら「1回のみ購入」に戻す
      buys.forEach(function (f) {
        var on = Number(f.dataset.variantIndex) === i;
        f.hidden = !on;
        if (on) {
          var radios = f.querySelectorAll('input[type="radio"]');
          Array.prototype.forEach.call(radios, function (r, n) { r.checked = n === 0; });
          Array.prototype.forEach.call(f.querySelectorAll('.purchase-option'), function (o, n) {
            o.classList.toggle('is-active', n === 0);
          });
        }
      });
      if (planInp) planInp.value = '';

      var b = btns[i];
      if (idInput) idInput.value = b.dataset.variantId;
      if (priceEl && b.dataset.price) priceEl.textContent = b.dataset.price;
      if (labelEl) labelEl.textContent = b.dataset.title || '';

      var ok = b.dataset.available === 'true';
      if (cartBtn) {
        cartBtn.disabled = !ok;
        if (cartTxt) cartTxt.textContent = ok ? 'カートに入れる' : '売り切れ';
      }
    }

    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { select(i); });
      b.addEventListener('keydown', function (e) {
        var next = i;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % btns.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + btns.length) % btns.length;
        else return;
        e.preventDefault();
        select(next);
        btns[next].focus();
      });
    });

    unselect();
  }

  // ------------------------------------------------------------------
  // 購入タイプ（都度 / 定期便）の切替
  // ------------------------------------------------------------------
  function initPurchaseType() {
    // お届け方法の枠はバリエーションごとに複数ある（出し分けは variant 選択側）。
    // selling_plan の hidden はフォームに1つだけなので、表示中の枠からのみ書き込む。
    var boxes = Array.prototype.slice.call(document.querySelectorAll('[data-purchase-type]'));
    if (!boxes.length) return;
    var hidden  = document.querySelector('[data-selling-plan]');
    var priceEl = document.querySelector('.price-large');

    boxes.forEach(function (box) {
      box.addEventListener('change', function (e) {
        if (e.target.type !== 'radio') return;
        if (box.hidden) return;   // 非表示バリエーションの枠は無視

        Array.prototype.forEach.call(box.querySelectorAll('.purchase-option'), function (o) {
          o.classList.toggle('is-active', o.contains(e.target));
        });
        if (hidden) hidden.value = e.target.value;

        // 上部の大きな価格表示も選択に合わせて更新
        var label = e.target.closest('.purchase-option');
        var pv = label && label.querySelector('.purchase-option-price');
        if (priceEl && pv) priceEl.textContent = pv.textContent.trim();
      });
    });
  }

  // ------------------------------------------------------------------
  // カートページのクーポン入力
  //   POST /cart/update.js の discount パラメータで適用・解除する。
  //   レスポンスの discount_codes[].applicable で成否がその場で分かる。
  //   金額表示は Liquid 描画のためリロードし、結果は sessionStorage で引き継ぐ。
  //   カートページから「チェックアウト以外」へ離れるときは自動で解除する。
  // ------------------------------------------------------------------
  var COUPON_RESULT_KEY = "kh-coupon-result";

  function postCartDiscount(code) {
    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
      body: "discount=" + encodeURIComponent(code),
    }).then(function (r) { return r.json(); });
  }

  function initCartCoupon() {
    var box = document.querySelector("[data-cart-coupon]");
    if (!box) return;
    var input = box.querySelector(".cart-coupon-input");
    var btn   = box.querySelector("[data-coupon-apply]");
    var note  = box.querySelector("[data-coupon-note]");
    var clear = document.querySelector("[data-coupon-clear]");

    function show(state, text) {
      note.hidden = false;
      note.className = "cart-coupon-note is-" + state;
      note.textContent = text;
    }

    function busy(on) {
      btn.disabled = on;
      btn.textContent = on ? "確認中…" : "適用";
      box.classList.toggle("is-busy", on);
    }

    function reloadWith(state, text) {
      try {
        sessionStorage.setItem(COUPON_RESULT_KEY, JSON.stringify({ state: state, text: text }));
      } catch (e) { /* 引き継げなくても処理自体は済んでいる */ }
      location.reload();
    }

    // リロードをまたいで結果メッセージを表示する
    try {
      var carried = sessionStorage.getItem(COUPON_RESULT_KEY);
      if (carried) {
        sessionStorage.removeItem(COUPON_RESULT_KEY);
        var parsed = JSON.parse(carried);
        show(parsed.state, parsed.text);
      }
    } catch (e) { /* sessionStorage が使えない環境は黙って無視する */ }

    function apply() {
      var code = (input.value || "").trim();
      note.hidden = true;
      if (!code) {
        show("error", "クーポンコードを入力してください。");
        input.focus();
        return;
      }
      busy(true);
      postCartDiscount(code)
        .then(function (cart) {
          var entry = (cart.discount_codes || []).filter(function (d) {
            return String(d.code).toLowerCase() === code.toLowerCase();
          })[0];
          if (entry && entry.applicable) {
            reloadWith("ok", "クーポン「" + entry.code + "」を適用しました。");
            return;
          }
          // 効かないコードはカートに残さない
          return postCartDiscount("").then(function () {
            busy(false);
            show("error", "「" + code + "」は適用できませんでした。"
                        + "コードに誤りがないか、対象商品がカートに入っているかをご確認ください。");
            input.select();
          });
        })
        .catch(function () {
          busy(false);
          show("error", "通信に失敗しました。時間をおいてお試しください。");
        });
    }

    btn.addEventListener("click", apply);
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); apply(); }
    });
    input.addEventListener("input", function () { note.hidden = true; });

    // 適用中クーポンの解除ボタン
    if (clear) {
      clear.addEventListener("click", function () {
        clear.disabled = true;
        postCartDiscount("")
          .then(function () { reloadWith("ok", "クーポンを解除しました。"); })
          .catch(function () { clear.disabled = false; });
      });
    }

    // ------------------------------------------------------------
    // カートを離れたら自動解除。ただしチェックアウトへ進むときは残す。
    // sendBeacon はページ遷移中でも送信が保証される。
    // ------------------------------------------------------------
    //
    // 既定は「保持」。カートから別ページへのリンクを踏んだときだけ解除する。
    //
    // 逆（既定で解除し、チェックアウトへの遷移だけ除外）にすると、
    // 検知漏れがそのまま「割引が消えた状態で決済画面へ進む」事故になる。
    // 検知漏れは実際に起こりうる（ページ再読み込み、スマホの引っ張って更新、
    // Shop Pay ボタンの iframe 内クリック、Enter でのフォーム送信など）。
    // こちら向きなら、判定を誤っても最悪クーポンが少し残るだけで済む。
    //
    var leavingToOtherPage = false;

    document.addEventListener("click", function (e) {
      var link = e.target.closest && e.target.closest("a[href]");
      if (!link) return;
      if (link.target === "_blank") return;
      var href = link.getAttribute("href") || "";
      if (/^(#|javascript:|mailto:|tel:)/i.test(href)) return;
      // カート内の操作とチェックアウトは離脱とみなさない
      if (/^\/(cart|checkout)/.test(href)) return;
      leavingToOtherPage = true;
    }, true);

    window.addEventListener("pagehide", function () {
      // リロード・タブを閉じる・チェックアウトへの遷移では解除しない
      if (!leavingToOtherPage) return;
      if (!document.querySelector(".cart-coupon-applied")) return;
      if (navigator.sendBeacon) {
        navigator.sendBeacon("/cart/update.js",
          new Blob(["discount="], { type: "application/x-www-form-urlencoded" }));
      }
    });

    // 戻るボタンで bfcache から復元されたときは金額表示が古いので読み直す
    window.addEventListener("pageshow", function (e) {
      if (e.persisted) location.reload();
    });
  }

  // ------------------------------------------------------------------
  // 商品画像のライトボックス（クリックで拡大）
  //   セクション側のインライン script は defer より先に走るため、
  //   こちらから [data-kh-zoom] を拾って初期化する。
  // ------------------------------------------------------------------
  function initProductLightbox() {
    var trigger = document.querySelector('[data-kh-zoom]');
    if (!trigger) return;
    var gallery = trigger.closest('[data-kh-gallery]');
    var thumbs  = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('.gallery-thumbs li')) : [];

    // 拡大対象の一覧。サムネイルが無い商品は主画像1枚だけを対象にする。
    var slides = thumbs.length
      ? thumbs.map(function (li) {
          return { src: li.dataset.mediaSrc, srcset: li.dataset.mediaSrcset };
        })
      : [{ src: trigger.currentSrc || trigger.src, srcset: trigger.getAttribute('srcset') }];

    var box, img, lastFocus, index = 0;

    function build() {
      box = document.createElement('div');
      box.className = 'kh-lightbox';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', '商品写真の拡大表示');
      box.innerHTML =
        '<button type="button" class="kh-lightbox-close" aria-label="閉じる">×</button>' +
        '<button type="button" class="kh-lightbox-nav is-prev" aria-label="前の写真">‹</button>' +
        '<figure class="kh-lightbox-figure"><img alt=""></figure>' +
        '<button type="button" class="kh-lightbox-nav is-next" aria-label="次の写真">›</button>';
      img = box.querySelector('img');
      document.body.appendChild(box);

      box.querySelector('.kh-lightbox-close').addEventListener('click', close);
      box.querySelector('.is-prev').addEventListener('click', function () { go(index - 1); });
      box.querySelector('.is-next').addEventListener('click', function () { go(index + 1); });
      box.addEventListener('click', function (e) { if (e.target === box) close(); });

      if (slides.length < 2) {
        box.querySelector('.is-prev').hidden = true;
        box.querySelector('.is-next').hidden = true;
      }
    }

    function go(i) {
      index = (i + slides.length) % slides.length;
      var s = slides[index];
      img.removeAttribute('srcset');
      img.src = s.src;
      if (s.srcset) img.setAttribute('srcset', s.srcset);
      img.alt = document.title + '（' + (index + 1) + '/' + slides.length + '）';
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(index - 1);
      else if (e.key === 'ArrowRight') go(index + 1);
    }

    function open() {
      if (!box) build();
      // 現在サムネイルで選択中のものを起点にする
      var active = gallery && gallery.querySelector('.gallery-thumbs li.is-active');
      go(active ? thumbs.indexOf(active) : 0);
      lastFocus = document.activeElement;
      box.classList.add('is-open');
      document.body.classList.add('kh-no-scroll');
      document.addEventListener('keydown', onKey);
      box.querySelector('.kh-lightbox-close').focus();
    }

    function close() {
      if (!box) return;
      box.classList.remove('is-open');
      document.body.classList.remove('kh-no-scroll');
      document.removeEventListener('keydown', onKey);
      if (lastFocus) lastFocus.focus();
    }

    trigger.addEventListener('click', open);
    trigger.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      open();
    });
  }

  // ------------------------------------------------------------------
  // レビュー
  //   保存先はセクション設定の endpoint で切り替える。
  //   endpoint が空のときは localStorage に保存する（公開前の確認用）。
  //   外部APIへ移行するときは、この store の list/submit だけ差し替える。
  // ------------------------------------------------------------------
  var reviewStore = (function () {
    var KEY = 'kh_reviews_v1';

    function readLocal() {
      try { return JSON.parse(window.localStorage.getItem(KEY) || '[]'); }
      catch (e) { return []; }
    }
    function writeLocal(list) {
      try { window.localStorage.setItem(KEY, JSON.stringify(list)); }
      catch (e) { /* プライベートモード等では保存しない */ }
    }

    function list(endpoint, productId) {
      if (!endpoint) {
        var all = readLocal();
        if (productId) {
          all = all.filter(function (r) { return String(r.product_id) === String(productId); });
        }
        return Promise.resolve(all);
      }
      var url = endpoint + (endpoint.indexOf('?') >= 0 ? '&' : '?') +
                (productId ? 'product_id=' + encodeURIComponent(productId) : 'scope=all');
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (d) { return Array.isArray(d) ? d : (d.reviews || []); });
    }

    function submit(endpoint, payload) {
      if (!endpoint) {
        var all = readLocal();
        all.unshift(payload);
        writeLocal(all);
        return Promise.resolve(payload);
      }
      return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json().catch(function () { return payload; });
      });
    }

    return { list: list, submit: submit };
  })();

  function starsMarkup(n) {
    var frag = document.createDocumentFragment();
    for (var i = 1; i <= 5; i++) {
      var s = document.createElement('span');
      s.textContent = '★';
      if (i > n) s.className = 'is-empty';
      frag.appendChild(s);
    }
    return frag;
  }

  function formatDate(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.getFullYear() + '.' +
           ('0' + (d.getMonth() + 1)).slice(-2) + '.' +
           ('0' + d.getDate()).slice(-2);
  }

  function buildReviewItem(r, scope) {
    var li = document.createElement('li');
    li.className = scope === 'all' ? 'review-item' : 'kh-review-item';

    var stars = document.createElement('p');
    stars.className = scope === 'all' ? 'review-stars' : 'kh-review-item-stars';
    stars.setAttribute('aria-label', '星' + r.rating + 'つ');
    stars.appendChild(starsMarkup(r.rating));
    li.appendChild(stars);

    var body = document.createElement('p');
    body.className = scope === 'all' ? 'review-text' : 'kh-review-item-body';
    body.textContent = r.body;             // textContent で入れるので HTML は混入しない
    li.appendChild(body);

    if (scope === 'all' && r.product_title) {
      var prod = document.createElement('p');
      prod.className = 'review-product';
      prod.textContent = '購入商品：' + r.product_title;
      li.appendChild(prod);
    }

    var parts = [r.nickname, r.age_group, r.gender, formatDate(r.created_at)].filter(Boolean);
    var meta = document.createElement('p');
    meta.className = scope === 'all' ? 'review-meta' : 'kh-review-item-meta';
    meta.textContent = parts.join(' · ');
    li.appendChild(meta);

    return li;
  }

  function initReviews() {
    var roots = document.querySelectorAll('[data-kh-reviews]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var scope     = root.dataset.scope || 'product';
      var endpoint  = (root.dataset.endpoint || '').trim();
      var listEl    = root.querySelector('[data-kh-review-list]');
      var emptyEl   = root.querySelector('[data-kh-review-empty]');
      var countEl   = root.querySelector('[data-kh-review-count]');
      var labelEl   = root.querySelector('[data-kh-review-count-label]');
      var scoreEl   = root.querySelector('[data-kh-review-score]');
      var seedCount = parseInt(root.dataset.seedCount, 10) || listEl.querySelectorAll('li').length;
      var seedTotal = parseInt(root.dataset.seedTotal, 10) || 0;
      var limit     = parseInt(root.dataset.limit, 10) || 0;

      function render(posted) {
        posted.sort(function (a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        if (limit) posted = posted.slice(0, limit);

        // 既に描画済みの投稿分だけ入れ替える（ダミーは Liquid 側のまま残す）
        listEl.querySelectorAll('[data-kh-posted]').forEach(function (el) { el.remove(); });
        var frag = document.createDocumentFragment();
        posted.forEach(function (r) {
          var li = buildReviewItem(r, scope);
          li.setAttribute('data-kh-posted', '');
          frag.appendChild(li);
        });
        listEl.insertBefore(frag, listEl.firstChild);

        var total = seedCount + posted.length;
        if (countEl) countEl.textContent = total;
        if (labelEl) labelEl.textContent = '購入者レビュー ' + total + ' 件';
        if (emptyEl) emptyEl.hidden = total > 0;

        if (scoreEl && root.dataset.scoreMode === 'average' && total > 0) {
          var sum = posted.reduce(function (a, r) { return a + Number(r.rating || 0); }, seedTotal);
          scoreEl.textContent = (sum / total).toFixed(1);
        }
      }

      reviewStore.list(endpoint, scope === 'product' ? root.dataset.productId : null)
        .then(render)
        .catch(function () { /* 取得失敗時はダミーのみ表示 */ });

      // --- 投稿フォーム（商品ページのみ） -------------------------------
      var form = root.querySelector('[data-kh-review-form]');
      if (!form) return;

      var openBtn  = root.querySelector('[data-kh-review-open]');
      var cancel   = root.querySelector('[data-kh-review-cancel]');
      var msg      = root.querySelector('[data-kh-review-message]');
      var textarea = form.querySelector('textarea[name="body"]');
      var counter  = form.querySelector('[data-kh-count]');

      if (openBtn) {
        openBtn.addEventListener('click', function () {
          form.hidden = !form.hidden;
          if (!form.hidden) form.querySelector('textarea, input').focus();
        });
      }
      if (cancel) {
        cancel.addEventListener('click', function () { form.hidden = true; });
      }
      if (textarea && counter) {
        textarea.addEventListener('input', function () {
          counter.textContent = textarea.value.length;
        });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!form.checkValidity()) { form.reportValidity(); return; }

        var data = new FormData(form);
        var payload = {
          product_id:    root.dataset.productId || '',
          product_title: root.dataset.productTitle || '',
          product_url:   root.dataset.productUrl || '',
          rating:        Number(data.get('rating')),
          body:          (data.get('body') || '').toString().trim(),
          nickname:      (data.get('nickname') || '').toString().trim(),
          age_group:     data.get('age_group') || '',
          gender:        data.get('gender') || '',
          created_at:    new Date().toISOString()
        };

        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = '送信中…'; }

        reviewStore.submit(endpoint, payload)
          .then(function () {
            form.reset();
            if (counter) counter.textContent = '0';
            form.hidden = true;
            if (msg) {
              msg.hidden = false;
              msg.className = 'kh-review-message is-success';
              msg.textContent = 'レビューを投稿しました。ありがとうございます。';
            }
            return reviewStore.list(endpoint, root.dataset.productId).then(render);
          })
          .catch(function () {
            if (msg) {
              msg.hidden = false;
              msg.className = 'kh-review-message is-error';
              msg.textContent = '投稿に失敗しました。時間をおいて再度お試しください。';
            }
          })
          .then(function () {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = '投稿する'; }
          });
      });
    });
  }

  // ------------------------------------------------------------------
  // カートのメッセージカード（無料サービス）
  //   チェックで入力欄を開き、文字数カウンタを出す。
  //   値は cart attributes として通常のカートフォームで送信される。
  // ------------------------------------------------------------------
  function initGiftMessage() {
    var box = document.querySelector('[data-kh-gift]');
    if (!box) return;
    var toggle  = box.querySelector('[data-kh-gift-toggle]');
    var panel   = box.querySelector('[data-kh-gift-panel]');
    var textarea= box.querySelector('[data-kh-gift-text]');
    var counter = box.querySelector('[data-kh-gift-count]');
    if (!toggle || !panel) return;

    function sync() {
      panel.hidden = !toggle.checked;
      if (textarea) textarea.required = toggle.checked;
    }
    toggle.addEventListener('change', sync);
    sync();

    if (textarea && counter) {
      var update = function () { counter.textContent = textarea.value.length; };
      textarea.addEventListener('input', update);
      update();
    }
  }

  // ------------------------------------------------------------------
  // ヘッダーのスクロール固定
  //   位置の制御は CSS の position: sticky に任せる。訴求バーとお知らせバーは
  //   そのまま流れ、ヘッダーだけが上端で止まる。
  //
  //   以前は JS で position: fixed へ切り替え、抜けた高さをスペーサーで
  //   補っていたが、測り直しのたびに一瞬だけ固定を解除するため、
  //   ページ高が縮んでスクロール位置が押し戻され、最下部でちらついていた。
  //   （モバイルはアドレスバーの出入りで resize が頻発するため特に顕著）
  //   sticky ならレイアウトが一切動かないので、この問題は起きない。
  //
  //   ここでの JS の役割は、固定中だけ影を出すためのクラス付けのみ。
  //   ヘッダーの手前に置いた番兵が画面外へ出たかどうかで判定するので、
  //   スクロールのたびに位置を測る必要がなく、レイアウトも変化しない。
  // ------------------------------------------------------------------
  function initStickyHeader() {
    var header = document.querySelector('.kh-section-header');
    if (!header) return;

    // 旧実装が差し込んだ要素が残っていれば取り除く
    ['.kh-header-spacer', '.kh-header-sentinel'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.remove();
    });

    // sticky なので、上端に貼り付いた時点で top が 0 になる。
    // 番兵要素を使う手もあるが、高さ 0 の要素は IntersectionObserver が
    // 面積 0 として扱い判定が安定しないため、ヘッダー自身の位置を見る。
    // 読み取りのみでレイアウトは変更しない。
    function sync() {
      header.classList.toggle('is-stuck', header.getBoundingClientRect().top <= 0);
    }

    sync();

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
  }

  // ------------------------------------------------------------------
  // FV 写真のパララックス
  //   枠より少し大きく表示した写真を、スクロールに合わせて上下に動かす。
  //   動かすのは写真だけで、枠やその周りのレイアウトは一切変わらない。
  //   （レイアウトを触るとスクロール位置が動いてちらつくため）
  // ------------------------------------------------------------------
  function initHeroParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var poster = document.querySelector('.hero-video-poster');
    if (!poster) return;
    var frame = poster.closest('.hero-video');
    if (!frame) return;

    // 余白を確保するクラス。JS が動くときだけ付けて、
    // 無効時に写真が中途半端に拡大されないようにする。
    frame.classList.add('has-parallax');

    var range = 0;
    function measure() {
      // CSS 側で高さを 144% にしているので、上下に 22% ずつ余地がある。
      // 動かす量はその内側の 20% に収めて、端が見えないようにする。
      range = frame.offsetHeight * 0.20;
    }

    function apply() {
      var rect = frame.getBoundingClientRect();
      var vh   = window.innerHeight || document.documentElement.clientHeight;
      if (rect.bottom < 0 || rect.top > vh) return;   // 画面外は計算しない

      // 枠の中心が画面中央より上なら負、下なら正（-1 〜 1）
      var center   = rect.top + rect.height / 2;
      var progress = (center - vh / 2) / (vh / 2 + rect.height / 2);
      progress = Math.max(-1, Math.min(1, progress));

      poster.style.transform = 'translate3d(0,' + (progress * range).toFixed(1) + 'px,0)';
    }

    measure();
    apply();

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { apply(); ticking = false; });
    }, { passive: true });

    window.addEventListener('load', function () { measure(); apply(); });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { measure(); apply(); }, 150);
    });
  }

  // ------------------------------------------------------------------
  // Init
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // トップのレビュースライダー
  //   同じ並びを2周ぶん出力してあるので、1周ぶんの幅だけ動かして
  //   先頭に戻せば途切れずにループする。その幅を実測して CSS へ渡す。
  //   （Instagram のスライダーと同じ考え方）
  // ------------------------------------------------------------------
  function initReviewSlider() {
    var track = document.querySelector('[data-kh-review-track]');
    if (!track) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var cells = track.children;
    if (cells.length < 2) return;
    var half = Math.floor(cells.length / 2);
    if (half < 1) return;

    function apply() {
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      var width = 0;
      for (var i = 0; i < half; i++) {
        width += cells[i].getBoundingClientRect().width + gap;
      }
      track.style.setProperty('--review-shift', width + 'px');
      // 1枚あたり約6秒で流れる速さ
      track.style.setProperty('--review-duration', (half * 6) + 's');
      track.classList.add('is-running');
    }

    apply();
    window.addEventListener('load', apply);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(apply, 150);
    });
  }

  // ------------------------------------------------------------------
  // 商品タブのラベルを電光掲示板のように流す
  //   タブは横に並べたまま、枠に入りきらないラベルだけを対象にする。
  //   先頭で少し止まる → 末尾まで流れる → 末尾で少し止まる →
  //   先頭に戻る、を繰り返す。実際の動きは CSS のアニメーションで、
  //   ここでは「どれだけ動かすか」「何秒かけるか」を測って渡すだけ。
  // ------------------------------------------------------------------
  function initTabMarquee() {
    var texts = document.querySelectorAll('.product-tabs .tab-btn-text');
    if (!texts.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var SPEED  = 52;   // px/秒
    var HOLD   = 2;    // 前後の静止に使う秒数の合計

    function apply() {
      Array.prototype.forEach.call(texts, function (t) {
        var btn = t.parentNode;

        // いったん解除してから測り直す
        t.classList.remove('is-marquee');
        btn.classList.remove('is-clipped');
        t.style.removeProperty('--tab-shift');
        t.style.removeProperty('--tab-duration');
        if (reduce) return;

        var cs    = getComputedStyle(btn);
        var avail = btn.clientWidth
                  - parseFloat(cs.paddingLeft)
                  - parseFloat(cs.paddingRight);
        var over  = Math.ceil(t.scrollWidth - avail);
        if (over <= 1) return;   // 収まっているものは動かさない

        t.style.setProperty('--tab-shift', over + 'px');
        t.style.setProperty('--tab-duration', (over / SPEED + HOLD).toFixed(2) + 's');
        t.classList.add('is-marquee');
        // 続きがあることを示す（流れるのはホバー中だけなので目印が要る）
        btn.classList.add('is-clipped');
      });
    }

    apply();
    window.addEventListener('load', apply);

    // フォントの読み込み後に幅が変わるため測り直す
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(apply);
    }

    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 150);
    });
  }

  // ------------------------------------------------------------------
  // 商品動画の遅延自動再生
  //   autoplay 属性を直接出すと読み込み時に動画全体のDLが走るため、
  //   preload=metadata で置いておき、画面に入ったら再生を始める。
  //   画面から出たら止めて、モバイルの通信量も抑える。
  // ------------------------------------------------------------------
  function initAutoVideo() {
    var frames = document.querySelectorAll('[data-kh-video-auto] video');
    if (!frames.length) return;

    if (!('IntersectionObserver' in window)) {
      // 古い環境では従来どおり即再生に倒す
      frames.forEach(function (v) { v.muted = true; v.play().catch(function () {}); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          v.muted = true;           // 自動再生の必須条件
          v.play().catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.35 });

    frames.forEach(function (v) { io.observe(v); });
  }

  function init() {
    initStickyHeader();
    initHeroParallax();
    initReviewSlider();
    initTabMarquee();
    initProductLightbox();
    initReviews();
    initGiftMessage();
    initMobileMenu();
    initCartButtons();
    initProductTabs();
    initQuantityPickers();
    initVariantSelect();
    initPurchaseType();
    initAutoVideo();
    initCartCoupon();
    initContactForm();
    initInstagramSlider();
    // initProductsFilter(); // Shopify ではコレクションURLで絞り込むため不要
    initFooterAccordion();
    initSnsTabs();
    // initPinScroll();       // 現行デザインでは未使用（[data-pin] なし）
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
